import React from "react";

export const LocationSpaceDetailsCardContent = ({ children }: { children: React.ReactNode }) => children;
LocationSpaceDetailsCardContent.displayName = "LocationSpaceDetailsCardContent";

export const LocationSpaceDetailsCardHeaderRight = ({ children }: { children: React.ReactNode }) => children;
LocationSpaceDetailsCardHeaderRight.displayName = "LocationSpaceDetailsCardHeaderRight";
